/**
 * Money utilities. All amounts are integer minor units.
 * Currency is a display-layer label — see docs/CONVENTIONS.md §2.
 */

export const BPS_TOTAL = 10_000 as const;

export function assertSafeMinorUnits(amount: number): void {
  if (!Number.isInteger(amount)) {
    throw new Error(`amount must be an integer minor-units value, got ${amount}`);
  }
  if (!Number.isSafeInteger(amount)) {
    throw new Error(`amount exceeds Number.MAX_SAFE_INTEGER: ${amount}`);
  }
}

export function formatMinorUnits(
  amount: number,
  currencyCode: string,
  minorUnitsPerMajor: number,
  locale = 'en-US',
): string {
  assertSafeMinorUnits(amount);
  const divisor = 10 ** minorUnitsPerMajor;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: minorUnitsPerMajor,
    maximumFractionDigits: minorUnitsPerMajor,
  }).format(amount / divisor);
}
